import {
  ProcessCellForExportParams,
  ProcessDataFromClipboardParams,
} from '@ag-grid-community/core';

import { Utils } from '@shared/utils/utils';

interface BaseStrategy {
  type: 'alphanumeric' | 'numeric';
}

interface CustomStrategy {
  parseFn: (params: ProcessCellForExportParams) => string;
  type: 'custom';
}

type ParteStrategy = BaseStrategy | CustomStrategy;

export function agParseValueFromClipboard<T>(
  params: ProcessCellForExportParams,
  pasteStrategy: Map<keyof T, ParteStrategy>
) {
  const colId = params.column.getColId() as keyof T | undefined;

  if (!colId) {
    return;
  }

  const strategy = pasteStrategy.get(colId);

  if (!strategy) return params.value;

  if (strategy.type === 'custom') {
    return strategy.parseFn(params);
  }

  if (strategy.type === 'numeric') {
    return Utils.castStringToNumber(params.value).toString();
  }

  if (strategy.type === 'alphanumeric') {
    return params.value;
  }

  return params.value;
}

export function agProcessCellFromClipboard(params: ProcessDataFromClipboardParams) {
  const lastRow = params.data[params.data.length - 1];

  if (lastRow && lastRow.every((cell) => cell === '')) {
    params.data.pop();
  }

  return params.data;
}
